import { BaseQuery, NonAbapInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToNonAbapInputUpdate = (q: BaseQuery, assignee?: string): NonAbapInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    fileName: q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.fileName : '',
    xtmProjectName:
      q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.xtmProjectName : '',
    collection: q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.collection : '',
    repository: q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.repository : '',
    sourceContact:
      q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.sourceContact : '',
    stringId: q.queryDetails?.__typename === 'NonAbapQuery' ? q.queryDetails?.stringId : ''
  };
};
